@switch (app.client.sizeId < 2)
  {
  <!--
  Mobile
  -->
    @case (true) {
    <div class="b-b b-col-5 p-b p-r-2 p-l-2">
        <div class="flex flex-justify-between cursor-pointer col-1 p-t"
             (click)="toggle()">

            <!-- title -->
            <div class="flex-grow w-12 _title">
                <span class="s2">{{'Sort' | translate}}</span>
            </div>

            <!-- icon -->
            <i class="icon-medium"
               [ngClass]="[toggleState ? 'icon-chevron-up' : 'icon-chevron-down']"></i>
        </div>

        <!-- body -->
        <div class="_animate"
             [hideUp]="toggleState">
            <div class="p-b-1 p-t flex flex-wrap"
                 style="gap: 12px;">
                @for (option of sort.getOptions(); track $index; let isLast = $last) {
                <button (click)="sort.by(option)"
                        [ngClass]="sort.selectionLabel === option.label ? 'bg-col-6' : 'bg-col-51'"
                        class="p-a-2 b-radius-4">
                    <p class="c1">{{option.label | translate}}</p>
                </button>
                }
            </div>
        </div>
    </div>
    }
    <!-- Default -->
    @default {
    <listing-dropdown class="inline-block m-l-1"
                      (valueChange)="sort.by($event)"
                      [options]="sort.getOptions()"
                      [rightPosition]="true">
        <ng-template #titleTpl>
            <p class="s2"> {{'Sort' | translate}} </p>
        </ng-template>
        <ng-template #optionTpl
                     let-option>
            <div [ngClass]="sort.selectionLabel === option.label ? 'bg-col-6' : 'bg-col-51'"
                 class="p-a-2 b-radius-4">
                <p class="c1">{{option.label | translate}}</p>
            </div>
        </ng-template>
    </listing-dropdown>
    }
    }
